import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {Box, HStack, Icon, Text} from 'platform/foundation';
import styled from 'styled-components';

import {LevelConfiguration} from '../types';

interface SortableLevelItemProps {
  levelConfiguration: LevelConfiguration;
}

const SortableItemWrapper = styled.div<{
  $transform: string | undefined;
  $transition: string | undefined;
  $isDragging: boolean;
}>`
  transform: ${({$transform}) => $transform};
  transition: ${({$transition}) => $transition};
  opacity: ${({$isDragging}) => ($isDragging ? 0 : 1)};
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
`;

export function SortableLevelItem(props: SortableLevelItemProps) {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: props.levelConfiguration.name,
  });
  const transformString = transform ? CSS.Transform.toString(transform) : undefined;

  return (
    <SortableItemWrapper
      ref={setNodeRef}
      $transform={transformString}
      $transition={transition}
      $isDragging={isDragging}
      {...attributes}
      {...listeners}
    >
      <Box backgroundColor="palettes.neutral.40.100" borderRadius="small" paddingHorizontal={3}>
        <HStack height={8} align="center" spacing={1}>
          <Icon value="action/drag_indicator" size={5} />
          <Text size="small">{props.levelConfiguration.title}</Text>
        </HStack>
      </Box>
    </SortableItemWrapper>
  );
}
